import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

/** Translated muscle names, primary first and then secondary: "Quads, Gluteus · Hamstrings". */
@Pipe({
  name: 'primaryMuscles',
  standalone: true,
})
export class PrimaryMusclesPipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform(
    primaryMuscles: string[] | null | undefined,
    activeLang?: string,
    secondaryMuscles?: string[] | null,
  ): string | undefined {
    const names = (muscles: string[] | null | undefined) =>
      (muscles ?? []).map((muscle) => this.translocoService.translate(muscle, {}, activeLang)).join(', ');

    const text = [names(primaryMuscles), names(secondaryMuscles)].filter(Boolean).join(' · ');
    return text || undefined;
  }
}
